// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --rev-green: #277a3e;
  --rev-green-dark: #17552a;
  --rev-green-soft: #eaf4ed;

  --rev-yellow: #f5d000;
  --rev-yellow-soft: #fff8cc;

  --white: #ffffff;
  --page-background: #f4f7f4;

  --text-primary: #17211a;
  --text-secondary: #617067;
  --border: #d9e2dc;
  --border-strong: #becbc2;

  --shadow:
    0 1px 2px rgba(23, 33, 26, 0.05),
    0 10px 28px rgba(23, 33, 26, 0.08);
}

.filters-panel {
  width: min(1180px, calc(100% - 40px));
  max-width: 100%;
  margin: 28px auto;
  padding: 28px;
  background: var(--white);
  border: 1px solid var(--border);
  border-top: 5px solid var(--rev-green);
  border-radius: 18px;
  box-shadow: var(--shadow);
  box-sizing: border-box;
}

.filters-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 22px;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--border);
}

.filters-eyebrow {
  display: block;
  margin-bottom: 5px;
  color: var(--rev-green);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.filters-header h1 {
  margin: 0;
  color: var(--text-primary);
  font-size: clamp(1.45rem, 2vw, 2rem);
  line-height: 1.2;
}

.filters-status {
  flex-shrink: 0;
  padding: 8px 13px;
  background: var(--rev-yellow-soft);
  border: 1px solid #ebd650;
  border-radius: 999px;
  color: #665700;
  font-size: 0.85rem;
  font-weight: 700;
}

.filters-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(300px, 0.65fr);
  gap: 24px;
  min-width: 0;
}

.filters-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}

.filters-column-right {
  padding-left: 24px;
  border-left: 1px solid var(--border);
}

.filter-section {
  min-width: 0;
  padding: 20px;
  background: #fbfcfb;
  border: 1px solid var(--border);
  border-radius: 14px;
}

.filter-section h2,
.field-title {
  display: block;
  margin: 0 0 5px;
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 750;
}

.filter-description {
  margin: 0 0 16px;
  color: var(--text-secondary);
  font-size: 0.87rem;
  line-height: 1.45;
}

.section-heading-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.charger-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.radio-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 44px;
  padding: 10px 12px;
  background: var(--white);
  border: 1px solid var(--border-strong);
  border-radius: 10px;
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 650;
  cursor: pointer;
  transition:
    border-color 160ms ease,
    background 160ms ease,
    transform 160ms ease,
    box-shadow 160ms ease;
}

.radio-card:hover {
  border-color: var(--rev-green);
  transform: translateY(-1px);
}

.radio-card-active {
  background: var(--rev-green-soft);
  border-color: var(--rev-green);
  box-shadow: 0 0 0 2px rgba(39, 122, 62, 0.1);
}

.radio-card input {
  accent-color: var(--rev-green);
}


/* REV-only control */

.rev-filter-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
  flex-wrap: wrap;
}

.rev-only-button {
  padding: 9px 15px;
  border: 1px solid #2f7f44;
  border-radius: 9px;
  background: #ffffff;
  color: #246b38;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease;
}

.rev-only-button:hover {
  background: #eef7f0;
}

.rev-only-button-active {
  background: #267b3c;
  border-color: #267b3c;
  color: #ffffff;
}

.rev-only-button-active:hover {
  background: #1f6833;
}

.rev-filter-description {
  color: #68756c;
  font-size: 0.88rem;
}


/* Location select/deselect controls */

.location-selection-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.location-action-button {
  padding: 8px 12px;
  border: 1px solid #2f7f44;
  border-radius: 8px;
  background: #ffffff;
  color: #246b38;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease;
}

.location-action-button:hover:not(:disabled) {
  background: #eef7f0;
}

.location-action-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}


/* Location list */

.locations-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
  max-height: 260px;
  min-width: 0;
  padding-right: 6px;
  overflow-y: auto;
}

.location-option {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  min-width: 0;
  min-height: 42px;
  padding: 9px 11px;
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 9px;
  cursor: pointer;
  transition:
    border-color 150ms ease,
    background 150ms ease;
}

.location-option:hover {
  background: var(--rev-green-soft);
  border-color: #9fc5a8;
}

.location-option:has(input:checked) {
  background: var(--rev-green-soft);
  border-color: var(--rev-green);
}

.location-option input {
  width: 16px;
  height: 16px;
  accent-color: var(--rev-green);
}

.location-name {
  min-width: 0;
  color: var(--text-primary);
  font-size: 0.86rem;
  line-height: 1.3;
}

.charger-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  padding: 3px 7px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.charger-badge-ac {
  color: var(--rev-green-dark);
  background: var(--rev-green-soft);
  border: 1px solid #a9ceb1;
}

.charger-badge-dc {
  color: #665700;
  background: var(--rev-yellow-soft);
  border: 1px solid #ebd650;
}

.no-locations-message {
  padding: 24px 16px;
  text-align: center;
  color: #68756c;
  font-size: 0.9rem;
}


/* Location summary and map */

.locations-map-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid var(--border);
}

.locations-map-summary {
  color: var(--text-secondary);
  font-size: 0.8rem;
  line-height: 1.4;
}

.view-map-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  min-height: 42px;
  padding: 9px 16px;
  color: #ffffff;
  background: var(--rev-green);
  border: 1px solid var(--rev-green);
  border-radius: 9px;
  font-family: inherit;
  font-size: 0.84rem;
  font-weight: 750;
  cursor: pointer;
  transition:
    background 150ms ease,
    border-color 150ms ease,
    transform 150ms ease;
}

.view-map-button:hover {
  background: var(--rev-green-dark);
  border-color: var(--rev-green-dark);
  transform: translateY(-1px);
}

.view-map-button:focus-visible {
  outline: 3px solid rgba(39, 122, 62, 0.22);
  outline-offset: 2px;
}

.view-map-button span {
  font-size: 1.1rem;
}


/* Date / grouping controls */

.date-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
  color: var(--text-primary);
  font-size: 0.83rem;
  font-weight: 650;
}

.field-group input,
.field-group select,
.filter-section select {
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  box-sizing: border-box;
  background: var(--white);
  border: 1px solid var(--border-strong);
  border-radius: 9px;
  color: var(--text-primary);
  font: inherit;
  outline: none;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease;
}

.field-group input:focus,
.field-group select:focus,
.filter-section select:focus {
  border-color: var(--rev-green);
  box-shadow: 0 0 0 3px rgba(39, 122, 62, 0.13);
}


/* Scrollbar */

.locations-list::-webkit-scrollbar {
  width: 8px;
}

.locations-list::-webkit-scrollbar-track {
  background: #edf1ee;
  border-radius: 999px;
}

.locations-list::-webkit-scrollbar-thumb {
  background: #afbeb3;
  border-radius: 999px;
}

.locations-list::-webkit-scrollbar-thumb:hover {
  background: var(--rev-green);
}


/* Tablet */

@media (max-width: 900px) {
  .filters-layout {
    grid-template-columns: 1fr;
  }

  .filters-column-right {
    padding-left: 0;
    padding-top: 22px;
    border-left: 0;
    border-top: 1px solid var(--border);
  }
}


/* Mobile */

@media (max-width: 640px) {
  .filters-panel {
    width: calc(100% - 20px);
    margin: 14px auto;
    padding: 18px;
    border-radius: 14px;
  }

  .filters-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .charger-options,
  .date-inputs,
  .locations-list {
    grid-template-columns: 1fr;
  }

  .locations-list {
    max-height: 360px;
  }

  .filters-status {
    align-self: flex-start;
  }

  .section-heading-row {
    flex-direction: column;
  }

  .locations-map-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .view-map-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Filters/Filters.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;;EAEzB,qBAAqB;EACrB,0BAA0B;;EAE1B,gBAAgB;EAChB,0BAA0B;;EAE1B,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,wBAAwB;;EAExB;;sCAEoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,wBAAwB;EACxB,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;;;;yBAIuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;;AAGA,qBAAqB;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf;;;0BAGwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;AAGA,sCAAsC;;AAEtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;0BAEwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA,kBAAkB;;AAElB;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;;AAGA,6BAA6B;;AAE7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;;;wBAGsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA,6BAA6B;;AAE7B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb;;yBAEuB;AACzB;;AAEA;;;EAGE,8BAA8B;EAC9B,6CAA6C;AAC/C;;;AAGA,cAAc;;AAEd;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA,WAAW;;AAEX;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mCAAmC;EACrC;AACF;;;AAGA,WAAW;;AAEX;EACE;IACE,wBAAwB;IACxB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[":root {\n  --rev-green: #277a3e;\n  --rev-green-dark: #17552a;\n  --rev-green-soft: #eaf4ed;\n\n  --rev-yellow: #f5d000;\n  --rev-yellow-soft: #fff8cc;\n\n  --white: #ffffff;\n  --page-background: #f4f7f4;\n\n  --text-primary: #17211a;\n  --text-secondary: #617067;\n  --border: #d9e2dc;\n  --border-strong: #becbc2;\n\n  --shadow:\n    0 1px 2px rgba(23, 33, 26, 0.05),\n    0 10px 28px rgba(23, 33, 26, 0.08);\n}\n\n.filters-panel {\n  width: min(1180px, calc(100% - 40px));\n  max-width: 100%;\n  margin: 28px auto;\n  padding: 28px;\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-top: 5px solid var(--rev-green);\n  border-radius: 18px;\n  box-shadow: var(--shadow);\n  box-sizing: border-box;\n}\n\n.filters-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  padding-bottom: 22px;\n  margin-bottom: 24px;\n  border-bottom: 1px solid var(--border);\n}\n\n.filters-eyebrow {\n  display: block;\n  margin-bottom: 5px;\n  color: var(--rev-green);\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.filters-header h1 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: clamp(1.45rem, 2vw, 2rem);\n  line-height: 1.2;\n}\n\n.filters-status {\n  flex-shrink: 0;\n  padding: 8px 13px;\n  background: var(--rev-yellow-soft);\n  border: 1px solid #ebd650;\n  border-radius: 999px;\n  color: #665700;\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n\n.filters-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(300px, 0.65fr);\n  gap: 24px;\n  min-width: 0;\n}\n\n.filters-column {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 0;\n}\n\n.filters-column-right {\n  padding-left: 24px;\n  border-left: 1px solid var(--border);\n}\n\n.filter-section {\n  min-width: 0;\n  padding: 20px;\n  background: #fbfcfb;\n  border: 1px solid var(--border);\n  border-radius: 14px;\n}\n\n.filter-section h2,\n.field-title {\n  display: block;\n  margin: 0 0 5px;\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-weight: 750;\n}\n\n.filter-description {\n  margin: 0 0 16px;\n  color: var(--text-secondary);\n  font-size: 0.87rem;\n  line-height: 1.45;\n}\n\n.section-heading-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n}\n\n.charger-options {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.radio-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  min-height: 44px;\n  padding: 10px 12px;\n  background: var(--white);\n  border: 1px solid var(--border-strong);\n  border-radius: 10px;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition:\n    border-color 160ms ease,\n    background 160ms ease,\n    transform 160ms ease,\n    box-shadow 160ms ease;\n}\n\n.radio-card:hover {\n  border-color: var(--rev-green);\n  transform: translateY(-1px);\n}\n\n.radio-card-active {\n  background: var(--rev-green-soft);\n  border-color: var(--rev-green);\n  box-shadow: 0 0 0 2px rgba(39, 122, 62, 0.1);\n}\n\n.radio-card input {\n  accent-color: var(--rev-green);\n}\n\n\n/* REV-only control */\n\n.rev-filter-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 14px;\n  flex-wrap: wrap;\n}\n\n.rev-only-button {\n  padding: 9px 15px;\n  border: 1px solid #2f7f44;\n  border-radius: 9px;\n  background: #ffffff;\n  color: #246b38;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    background 0.2s ease,\n    color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.rev-only-button:hover {\n  background: #eef7f0;\n}\n\n.rev-only-button-active {\n  background: #267b3c;\n  border-color: #267b3c;\n  color: #ffffff;\n}\n\n.rev-only-button-active:hover {\n  background: #1f6833;\n}\n\n.rev-filter-description {\n  color: #68756c;\n  font-size: 0.88rem;\n}\n\n\n/* Location select/deselect controls */\n\n.location-selection-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.location-action-button {\n  padding: 8px 12px;\n  border: 1px solid #2f7f44;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #246b38;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.location-action-button:hover:not(:disabled) {\n  background: #eef7f0;\n}\n\n.location-action-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n\n/* Location list */\n\n.locations-list {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 9px;\n  max-height: 260px;\n  min-width: 0;\n  padding-right: 6px;\n  overflow-y: auto;\n}\n\n.location-option {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 9px;\n  min-width: 0;\n  min-height: 42px;\n  padding: 9px 11px;\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  cursor: pointer;\n  transition:\n    border-color 150ms ease,\n    background 150ms ease;\n}\n\n.location-option:hover {\n  background: var(--rev-green-soft);\n  border-color: #9fc5a8;\n}\n\n.location-option:has(input:checked) {\n  background: var(--rev-green-soft);\n  border-color: var(--rev-green);\n}\n\n.location-option input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--rev-green);\n}\n\n.location-name {\n  min-width: 0;\n  color: var(--text-primary);\n  font-size: 0.86rem;\n  line-height: 1.3;\n}\n\n.charger-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 30px;\n  padding: 3px 7px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.charger-badge-ac {\n  color: var(--rev-green-dark);\n  background: var(--rev-green-soft);\n  border: 1px solid #a9ceb1;\n}\n\n.charger-badge-dc {\n  color: #665700;\n  background: var(--rev-yellow-soft);\n  border: 1px solid #ebd650;\n}\n\n.no-locations-message {\n  padding: 24px 16px;\n  text-align: center;\n  color: #68756c;\n  font-size: 0.9rem;\n}\n\n\n/* Location summary and map */\n\n.locations-map-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding-top: 16px;\n  margin-top: 16px;\n  border-top: 1px solid var(--border);\n}\n\n.locations-map-summary {\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.view-map-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-shrink: 0;\n  min-height: 42px;\n  padding: 9px 16px;\n  color: #ffffff;\n  background: var(--rev-green);\n  border: 1px solid var(--rev-green);\n  border-radius: 9px;\n  font-family: inherit;\n  font-size: 0.84rem;\n  font-weight: 750;\n  cursor: pointer;\n  transition:\n    background 150ms ease,\n    border-color 150ms ease,\n    transform 150ms ease;\n}\n\n.view-map-button:hover {\n  background: var(--rev-green-dark);\n  border-color: var(--rev-green-dark);\n  transform: translateY(-1px);\n}\n\n.view-map-button:focus-visible {\n  outline: 3px solid rgba(39, 122, 62, 0.22);\n  outline-offset: 2px;\n}\n\n.view-map-button span {\n  font-size: 1.1rem;\n}\n\n\n/* Date / grouping controls */\n\n.date-inputs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  min-width: 0;\n  color: var(--text-primary);\n  font-size: 0.83rem;\n  font-weight: 650;\n}\n\n.field-group input,\n.field-group select,\n.filter-section select {\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 12px;\n  box-sizing: border-box;\n  background: var(--white);\n  border: 1px solid var(--border-strong);\n  border-radius: 9px;\n  color: var(--text-primary);\n  font: inherit;\n  outline: none;\n  transition:\n    border-color 150ms ease,\n    box-shadow 150ms ease;\n}\n\n.field-group input:focus,\n.field-group select:focus,\n.filter-section select:focus {\n  border-color: var(--rev-green);\n  box-shadow: 0 0 0 3px rgba(39, 122, 62, 0.13);\n}\n\n\n/* Scrollbar */\n\n.locations-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.locations-list::-webkit-scrollbar-track {\n  background: #edf1ee;\n  border-radius: 999px;\n}\n\n.locations-list::-webkit-scrollbar-thumb {\n  background: #afbeb3;\n  border-radius: 999px;\n}\n\n.locations-list::-webkit-scrollbar-thumb:hover {\n  background: var(--rev-green);\n}\n\n\n/* Tablet */\n\n@media (max-width: 900px) {\n  .filters-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .filters-column-right {\n    padding-left: 0;\n    padding-top: 22px;\n    border-left: 0;\n    border-top: 1px solid var(--border);\n  }\n}\n\n\n/* Mobile */\n\n@media (max-width: 640px) {\n  .filters-panel {\n    width: calc(100% - 20px);\n    margin: 14px auto;\n    padding: 18px;\n    border-radius: 14px;\n  }\n\n  .filters-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .charger-options,\n  .date-inputs,\n  .locations-list {\n    grid-template-columns: 1fr;\n  }\n\n  .locations-list {\n    max-height: 360px;\n  }\n\n  .filters-status {\n    align-self: flex-start;\n  }\n\n  .section-heading-row {\n    flex-direction: column;\n  }\n\n  .locations-map-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .view-map-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
